/* ==========================================================================
   Zooted Prestige — age-gate.js
   Full-screen 21+ verification. Runs before anything else is interactive.
   Verification is remembered in localStorage (with a cookie fallback) for
   the number of days configured in Theme Settings > Age verification.
   ========================================================================== */
(function () {
  'use strict';

  var settings = (window.zootedSettings && window.zootedSettings.ageGate) || {};
  if (!settings.enabled) return;

  var KEY = 'zooted_age_verified';
  var days = Number(settings.days) || 30;
  var gate = document.getElementById('AgeGate');
  if (!gate) return;

  // Never lock the Shopify Theme Editor preview.
  if (window.Shopify && window.Shopify.designMode) return;

  function readVerification() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (raw) {
        var data = JSON.parse(raw);
        if (data && data.expires && Date.now() < data.expires) return true;
        window.localStorage.removeItem(KEY);
      }
    } catch (err) { /* storage unavailable — fall through to cookie */ }
    return document.cookie.split(';').some(function (c) { return c.trim().indexOf(KEY + '=1') === 0; });
  }

  function saveVerification() {
    var expires = Date.now() + days * 86400000;
    try {
      window.localStorage.setItem(KEY, JSON.stringify({ expires: expires }));
    } catch (err) { /* ignore */ }
    document.cookie = KEY + '=1; max-age=' + days * 86400 + '; path=/; SameSite=Lax';
  }

  function lock() {
    document.body.classList.add('age-gate-locked', 'no-scroll');
    gate.removeAttribute('hidden');
    var enter = gate.querySelector('[data-age-enter]');
    if (enter) enter.focus();

    gate.addEventListener('keydown', function (e) {
      if (e.key === 'Tab' && window.zootedTrapFocus) window.zootedTrapFocus(gate, e);
      if (e.key === 'Escape') e.preventDefault(); // no escaping the gate
    });
  }

  function unlock() {
    document.body.classList.remove('age-gate-locked', 'no-scroll', 'age-gate-active');
    document.documentElement.classList.remove('age-unverified');
    gate.setAttribute('hidden', '');
  }

  function init() {
    if (readVerification()) { unlock(); return; }
    lock();
    var enter = gate.querySelector('[data-age-enter]');
    var exit = gate.querySelector('[data-age-exit]');
    if (enter) enter.addEventListener('click', function () {
      saveVerification();
      unlock();
    });
    if (exit) exit.addEventListener('click', function () {
      window.location.href = settings.exitUrl || 'https://www.google.com';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
